
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

export default class LoginController {
    constructor($rootScope, $log, $state, Session) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Session = Session;

        this.state = {
            isCreditVisible: false
        }
    }

    $onInit(){
        let data = this.Session.get();
        
        if (!_.isEmpty(data)){
            this.$state.go("main");
        }
    }
    
    submit(){
        this.Session.create();
        this.$state.go('main');
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js